import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { MenuPrincipalComponent } from './menu-principal/menu-principal.component';
import { DialogoGenericoComponent } from './dialogo-generico/dialogo-generico.component';
import { DialogInformationComponent } from './components/dialog-information/dialog-information.component';
import { DateDataActualComponent } from './components/date-data-actual/date-data-actual.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './http-error-interceptor';
import { AuthGuard } from './auth-guard';
import { BottomSheetOverviewComponent } from './components/bottom-sheet-overview/bottom-sheet-overview.component';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    RouterModule,
    MatMenuModule,
    FlexLayoutModule,
    MatRippleModule
  ],
  declarations: [
    MenuPrincipalComponent,
    DialogoGenericoComponent,
    DialogInformationComponent,
    DateDataActualComponent,
    BottomSheetOverviewComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    AuthGuard
  ]
})
export class SharedModule { }
